import React, { useState, useEffect } from "react";
import {
  Dialog, DialogContent, Box, Typography, Grid, Stack,
  TextField, Button, Avatar, InputAdornment, Tooltip, MenuItem
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import convoBg from "../../../assests/convoBg.jpg";
import { QR, qrCardSx, qrDialogPaperSx, QrModalHeader, QrActionButton } from "../../qrCode/components/qrUi";
import { nameColor, nameInitials } from "../../branchDepartment/components/nameCardList";
import Slide from "@mui/material/Slide";
import { useSelector, useDispatch } from "react-redux";
import SnackbarMessage from "../../../components/snackBar/snackBar";
import PhoneIcon from "@mui/icons-material/Phone";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ChatIcon from '@mui/icons-material/Chat';
import { sendWaConvoTemplateThunk } from "../messagesThunk";
import { getCampaignInputParamsThunk } from "../../campaign/campaignThunk";
import ClearIcon from '@mui/icons-material/Clear';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function WaTemplates({ show, handleClose, handleMessageSubmit }) {
  const { getTemplates } = useSelector((state) => state.templates);
  const { selectedUser, status2, error } = useSelector((state) => state.messages);
  const { campaignInputParams = [] } = useSelector((state) => state.campaigns);

  const dispatch = useDispatch();

  const approvedTemplates = getTemplates.filter(
    (item) => item.status === "Approved"
  );



  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [state, setState] = useState({
    selectedTemplateData: [],
    headerTextDataDeatils: "",
    bodyTextDataDetails: "",
    responseMessage: "",
    searchTemplate: "",
    errors: {},
    selectPlaceHolderOptions: "1"
  });

  const { selectedTemplateData, searchTemplate, selectPlaceHolderOptions } = state;

  const [headerInputs, setHeaderInputs] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleOptionChange = (event) => {
    setState((prev) => ({
      ...prev,
      selectPlaceHolderOptions: event.target.value,
      responseMessage: "",
      searchTemplate: "",
      errors: {},
    }));
    setHeaderInputs([]);
    setInputs([]);
  };

  useEffect(() => {
    dispatch(getCampaignInputParamsThunk());
  }, [dispatch])


  const templateFormData =
    (selectedTemplateData[0] || {}).template_form instanceof Array
      ? (selectedTemplateData[0] || {}).template_form
      : (selectedTemplateData[0] || {}).template_form
        ? (selectedTemplateData[0] || {}).template_form.components
        : [];

  const { headerText, bodyText, footerText, buttons, image, video, document } =
    Array.isArray(templateFormData)
      ? templateFormData.reduce((accumulator, { type, text, format, example, buttons }) => {
        const normalizedFormat = format ? format.toLowerCase() : "";

        if (type === "HEADER") {
          if (normalizedFormat === "image" && example?.header_handle) {
            accumulator.image = example.header_handle[0];
          } else if (normalizedFormat === "video" && example?.header_handle) {
            accumulator.video = example.header_handle[0];
          } else if (normalizedFormat === "document" && example?.header_handle) {
            accumulator.document = example.header_handle[0];
          } else {
            accumulator.headerText = text;
          }
        } else if (type === "BODY") {
          accumulator.bodyText = text;
        } else if (type === "FOOTER") {
          accumulator.footerText = text;
        } else if (type === "BUTTONS") {
          accumulator.buttons = buttons;
        }
        return accumulator;
      }, {})
      : {};

  const placeholderRegex = /\{\{(\d+)\}\}/g;
  const textParts = (bodyText || "").split(placeholderRegex);
  const headerTextParts = (headerText || "").split(placeholderRegex);


  const handleSelectionChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    const selectedTemplate =
      approvedTemplates.find((item) => item.id === selectedOption.value) || {};
    setState((prevState) => ({
      ...prevState,
      selectedTemplateData: [selectedTemplate],
      errors: {},
      selectPlaceHolderOptions: "1"
    }));

    const templateFormData1 = (selectedTemplate || {}).template_form || [];

    const { bodyText1, headerText1 } = Array.isArray(templateFormData1)
      ? templateFormData1.reduce((acc, { type, text }) => {
        if (type === "BODY") acc.bodyText1 = text;
        if (type === "HEADER") acc.headerText1 = text;
        return acc;
      }, {})
      : {};

    setState((prevState) => ({
      ...prevState,
      headerTextDataDeatils: headerText1,
      bodyTextDataDetails: bodyText1,
    }));

    const placeholderRegex1 = /\{\{(\d+)\}\}/g;
    const placeholderHeader = (headerText1 || "").match(placeholderRegex1) || [];
    const placeholder = (bodyText1 || "").match(placeholderRegex1) || [];

    setInputs(Array(placeholder.length).fill(""));
    setHeaderInputs(Array(placeholderHeader.length).fill(""));
  };

  const handleHeaderInputChange = (index, value) => {

    // if (state.errors[`header_${index}`]) {
    //   value = ""; // clear the input
    //   setState(prev => ({
    //     ...prev,
    //     errors: { ...prev.errors, [`header_${index}`]: "" } 
    //   }));
    // }

    const newInputs = [...headerInputs];
    newInputs[index] = value;
    setHeaderInputs(newInputs);
    setState(prev => ({
      ...prev,
      errors: {},
    }));
  };

  const handleInputChange = (index, value) => {
    const newInputs = [...inputs];
    newInputs[index] = value;
    setInputs(newInputs);

    setState(prev => ({
      ...prev,
      errors: {},
    }));
  };

  const handleButtonClick = (action) => {
    window.location.href = action;
  };

  const formatText = (text) => {
    if (!text || typeof text !== "string") return "";
    return text
      .replace(/\*([^*]+)\*/g, "<strong>$1</strong>")
      .replace(/\\n/g, "\n")
      .replace(/(https?:\/\/)([^ ]+)/g, '<a target="_blank" href="$&">$2</a>');
  };

  const headerTextFormat = (state.headerTextDataDeatils || "")
    .replace(/\n/g, "<br>")
    .replace(/ \*(\S*?)\* /g, " <b>$1</b> ");
  const bodyTextFormat = (state.bodyTextDataDetails || "")
    .replace(/\n/g, "<br>")
    .replace(/ \*(\S*?)\* /g, " <b>$1</b> ");

  const handleChange = (e) => {
    setState((prev) => ({ ...prev, searchTemplate: e.target.value.replace(/^\s+/, "").slice(0, 10) }));
  };

  const templeData = approvedTemplates.map((item) => ({
    value: item.id,
    label: item.template_name,
  }));
  const filteredTemplates = templeData.filter((item) =>
    item.label.toLowerCase().includes(searchTemplate.toLowerCase())
  );



  const validateForm = () => {
    let validations = [];

    if (selectedOption === null) {
      validations.push({
        field: 'template',
        valid: false,
        message: "Template is required",
      });
    }

    // validate header inputs
    headerInputs.forEach((val, i) => {
      if (!val.trim()) {
        validations.push({
          field: `header_${i}`,
          valid: false,
          message: `Header variable ${i + 1} is required`,
        });
      }
    });

    // validate body inputs
    inputs.forEach((val, i) => {
      if (!val.trim()) {
        validations.push({
          field: `body_${i}`,
          valid: false,
          message: `Body variable ${i + 1} is required`,
        });
      }
    });

    if (validations.length > 0) {
      // pick first failed validation for snackbar
      const firstError = validations[0];

      setSnackbar({
        open: true,
        message: firstError.message,
        severity: "error",
      });

      // build errors object
      const errors = {};
      validations.forEach((rule) => {
        errors[rule.field] = rule.message;
      });

      setState((prev) => ({
        ...prev,
        errors,
      }));

      return false;
    }

    setState((prev) => ({
      ...prev,
      errors: {}, // clear errors
    }));

    return true;
  };


  const handleSubmit = async (e) => {

    const isValid = validateForm();
    if (!isValid) return;

    e.preventDefault();

    const headerInputsData = headerInputs.map((text, index) => ({ type: "text", text }));
    const bodyInputsData = inputs.map((text, index) => ({ type: "text", text }));


    const variables = [];

    const getMappedText = (text) => {
      if (selectPlaceHolderOptions === "2") {
        const match = campaignInputParams.find(
          (item) => item.template_variable === text
        );
        return match ? match.id : text;
      }
      return text;
    };

    if (headerInputsData.length > 0) {
      variables.push({
        type: "header",
        parameters: headerInputsData.map((item) => ({
          "type": item.type,
          "text": getMappedText(item.text),
          "mode": "static",
          "key": ""
        })),
      });
    }

    // Add body section if any body data
    if (bodyInputsData.length > 0) {
      variables.push({
        type: "body",
        parameters: bodyInputsData.map((item) => ({
          "type": item.type,
          "text": getMappedText(item.text),
          "mode": "static",
          "key": ""
        })),
      });
    }

    try {
      const result = await dispatch(
        sendWaConvoTemplateThunk({
          credentials: {
            "receiver_contact_id": selectedUser,
            "template_id": selectedOption?.value,
            "variables": variables
          }
        })
      );

      if (result.meta.requestStatus === "fulfilled") {
        setSnackbar({
          open: true,
          message: result.payload.message,
          severity: "success",
        });
        handleClose();
      } else {
        setSnackbar({
          open: true,
          message: result.payload,
          severity: "error",
        });
      }
    } catch {
      setSnackbar({
        open: true,
        message: "Server error. Please try again.",
        severity: "error",
      });
    }
  }


  useEffect(() => {
    if (error !== null) {
      setSnackbar({
        open: true,
        message: error,
        severity: "error",
      });
    }
  }, [error]);


  // Variable input look (same as the field kit)
  const varFieldSx = {
    "& .MuiOutlinedInput-root": {
      height: 42,
      borderRadius: 2.5,
      bgcolor: "#fff",
      fontSize: 14,
      "& .MuiOutlinedInput-notchedOutline": { borderWidth: "1.5px", borderColor: "#e5e7eb" },
      "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#cbd5e1" },
      "&.Mui-focused": { boxShadow: "0 0 0 4px rgba(25,135,84,0.14)" },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderWidth: "1.5px", borderColor: QR.main },
      "&.Mui-error .MuiOutlinedInput-notchedOutline": { borderColor: "#ef4444" },
    },
    "& input::placeholder": { color: "#9ca3af", opacity: 1 },
  };

  const sectionLabelSx = { fontSize: 12, fontWeight: 800, letterSpacing: 0.6, textTransform: "uppercase", color: "#4b5563" };

  // One variable row: {{n}} chip + input (or select)
  const renderVariable = (part, index, value, onValue, errorKey) => (
    <Stack key={index} direction="row" alignItems="center" spacing={1.25} sx={{ mt: 1.25 }}>
      <Box sx={{ flexShrink: 0, minWidth: 52, textAlign: "center", px: 1, py: 0.4, borderRadius: 1.5, fontFamily: "monospace", fontSize: 13, fontWeight: 700, color: QR.main, bgcolor: `${QR.main}12`, border: `1px solid ${QR.main}33` }}>
        {`{{${part}}}`}
      </Box>
      {selectPlaceHolderOptions === "1" ? (
        <TextField
          inputProps={{ maxLength: 20 }}
          fullWidth
          size="small"
          error={!!state.errors[errorKey]}
          value={value || ""}
          onChange={(e) => onValue(e.target.value)}
          placeholder={`Enter text for {{${part}}}`}
          sx={varFieldSx}
        />
      ) : (
        <TextField
          select
          fullWidth
          size="small"
          value={value || ""}
          onChange={(e) => onValue(e.target.value)}
          SelectProps={{ displayEmpty: true, renderValue: (v) => v || <Box component="span" sx={{ color: "#9ca3af" }}>Select option</Box> }}
          sx={varFieldSx}
        >
          {campaignInputParams.map((item) => (
            <MenuItem key={item.id} value={item.template_variable}>
              {item.template_variable}
            </MenuItem>
          ))}
        </TextField>
      )}
    </Stack>
  );

  const hasVariables = headerTextParts.length > 1 || textParts.length > 1;

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth="md"
      keepMounted
      PaperProps={{ sx: qrDialogPaperSx }}
    >
      {/* Header */}
      <QrModalHeader
        icon={<DescriptionOutlinedIcon />}
        title="Approved Templates"
        subtitle={selectedOption ? `Selected: ${selectedOption.label}` : "Pick a template to preview and send"}
        onClose={handleClose}
      />

      <DialogContent sx={{ p: { xs: 1.5, sm: 2.5 }, bgcolor: "#f8fafc" }}>
        <Grid container spacing={2}>
          {/* ---------- Left: search + template list ---------- */}
          <Grid size={{ xs: 12, md: 5 }}>
            <Box sx={{ ...qrCardSx, borderTop: `1px solid ${QR.border}`, bgcolor: "#fff", display: "flex", flexDirection: "column", height: { md: "58vh" } }}>
              <Box sx={{ p: 1.5, borderBottom: `1px solid ${QR.border}`, bgcolor: "#fafbfc" }}>
                <TextField
                  fullWidth
                  size="small"
                  value={searchTemplate}
                  onChange={handleChange}
                  placeholder="Search template..."
                  inputProps={{ maxLength: 10 }}
                  sx={varFieldSx}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ fontSize: 19, color: searchTemplate ? QR.main : "#9ca3af" }} />
                      </InputAdornment>
                    ),
                    endAdornment: searchTemplate ? (
                      <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                        <Tooltip title="Clear">
                          <ClearIcon
                            onClick={() => setState(prev => ({ ...prev, searchTemplate: "" }))}
                            sx={{ fontSize: 18, color: "#94a3b8", "&:hover": { color: "#ef4444" } }}
                          />
                        </Tooltip>
                      </InputAdornment>
                    ) : null,
                  }}
                />
                <Typography sx={{ mt: 1, fontSize: 12, fontWeight: 700, color: QR.slate }}>
                  {filteredTemplates.length} {filteredTemplates.length === 1 ? "template" : "templates"}
                </Typography>
              </Box>

              <Box sx={{ flex: 1, minHeight: 0, maxHeight: { xs: "32vh", md: "none" }, overflowY: "auto", p: 1, scrollbarWidth: "thin" }}>
                {filteredTemplates.length > 0 ? (
                  <Stack spacing={0.75}>
                    {filteredTemplates.map((item) => {
                      const c = nameColor(item.label || "");
                      const active = selectedOption?.value === item.value;
                      return (
                        <Box
                          key={item.id}
                          onClick={() => handleSelectionChange(item)}
                          title={item.label}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.25,
                            minWidth: 0,
                            px: 1.25,
                            py: 1,
                            cursor: "pointer",
                            borderRadius: 2.5,
                            border: `1px solid ${active ? `${QR.main}66` : "transparent"}`,
                            borderLeft: `3px solid ${active ? QR.main : "transparent"}`,
                            bgcolor: active ? `${QR.main}0d` : "transparent",
                            transition: "all .15s ease",
                            "&:hover": { bgcolor: active ? `${QR.main}12` : "#f1f5f9" },
                          }}
                        >
                          <Avatar sx={{ width: 34, height: 34, flexShrink: 0, fontSize: 12.5, fontWeight: 800, color: "#fff", background: `linear-gradient(135deg, ${c}, ${c}b3)`, boxShadow: `0 0 0 3px #fff, 0 0 0 4px ${c}40` }}>
                            {nameInitials((item.label || "").replace(/_/g, " "))}
                          </Avatar>
                          <Typography noWrap sx={{ flex: 1, minWidth: 0, fontSize: 13.5, fontWeight: active ? 800 : 600, color: active ? QR.dark : "#0f172a" }}>
                            {item.label}
                          </Typography>
                          {active && <CheckCircleIcon sx={{ fontSize: 18, color: QR.main, flexShrink: 0 }} />}
                        </Box>
                      );
                    })}
                  </Stack>
                ) : (
                  <Stack alignItems="center" spacing={0.75} sx={{ py: 5, textAlign: "center" }}>
                    <SearchOffIcon sx={{ fontSize: 30, color: "#cbd5e1" }} />
                    <Typography sx={{ fontSize: 13.5, fontWeight: 700, color: "#64748b" }}>No approved templates found</Typography>
                  </Stack>
                )}
              </Box>
            </Box>
          </Grid>

          {/* ---------- Right: preview + variables ---------- */}
          <Grid size={{ xs: 12, md: 7 }}>
            <Box sx={{ ...qrCardSx, borderTop: `1px solid ${QR.border}`, bgcolor: "#fff", display: "flex", flexDirection: "column", height: { md: "58vh" } }}>
              <Stack direction="row" alignItems="center" spacing={1} sx={{ px: 2, py: 1.25, borderBottom: `1px solid ${QR.border}` }}>
                <WhatsAppIcon sx={{ fontSize: 19, color: "#16a34a" }} />
                <Typography sx={{ fontSize: 14.5, fontWeight: 700, color: "#0f172a" }}>Preview</Typography>
              </Stack>

              <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", scrollbarWidth: "thin" }}>
                {selectedOption && selectedTemplateData.length > 0 ? (
                  <>
                    {/* WhatsApp-style bubble */}
                    <Box sx={{ p: { xs: 1.5, sm: 2 }, bgcolor: "#efeae2", backgroundImage: `url(${convoBg})`, backgroundRepeat: "repeat", backgroundSize: "300px auto" }}>
                      <Box sx={{ maxWidth: 380, mx: "auto", overflow: "hidden", overflowWrap: "anywhere", borderRadius: "12px", bgcolor: "#d9fdd3", boxShadow: "0 1px 0.5px rgba(11,20,26,0.13)" }}>
                        {image && (
                          <Box sx={{ p: 0.5 }}>
                            <img src={image} alt="Template" style={{ display: "block", width: "100%", maxHeight: 220, objectFit: "cover", borderRadius: 9 }} />
                          </Box>
                        )}
                        {video && (
                          <Box sx={{ p: 0.5 }}>
                            <video controls style={{ display: "block", width: "100%", height: 180, borderRadius: 9, background: "#000" }}>
                              <source src={video} type="video/mp4" />
                            </video>
                          </Box>
                        )}
                        {document && (
                          <Box sx={{ m: 0.75, p: 1.25, borderRadius: 2, bgcolor: "rgba(255,255,255,0.6)", textAlign: "center" }}>
                            <a href={document} target="_blank" rel="noopener noreferrer">View Document</a>
                          </Box>
                        )}

                        <Box sx={{ px: 1.5, pt: 1, pb: footerText ? 0.5 : 1.25, fontSize: 13.5, lineHeight: 1.55, color: "#111b21" }}>
                          {headerTextFormat && <Box sx={{ fontWeight: 700, mb: 0.5 }} dangerouslySetInnerHTML={{ __html: formatText(headerTextFormat) }} />}
                          <div style={{ whiteSpace: "pre-line" }} dangerouslySetInnerHTML={{ __html: formatText(bodyTextFormat) }} />
                        </Box>
                        {footerText && (
                          <Typography sx={{ px: 1.5, pb: 1.25, fontSize: 12, color: "#667781" }}>{footerText}</Typography>
                        )}

                        {buttons && buttons.length > 0 && (
                          <Box sx={{ borderTop: "1px solid rgba(11,20,26,0.1)" }}>
                            {buttons.map((button, index) => (
                              <Button
                                key={index}
                                fullWidth
                                onClick={() => handleButtonClick(button.url)}
                                startIcon={button.type === "QUICK_REPLY" ? <ChatIcon /> : button.type === "url" ? <OpenInNewIcon /> : <PhoneIcon />}
                                sx={{
                                  justifyContent: "center",
                                  textTransform: "none",
                                  fontWeight: 600,
                                  fontSize: 13.5,
                                  color: "#027eb5",
                                  borderRadius: 0,
                                  py: 0.75,
                                  borderTop: index > 0 ? "1px solid rgba(11,20,26,0.1)" : "none",
                                  "&:hover": { bgcolor: "rgba(2,126,181,0.06)" },
                                }}
                              >
                                {button.text}
                              </Button>
                            ))}
                          </Box>
                        )}
                      </Box>
                    </Box>

                    {/* Variables */}
                    {hasVariables && (
                      <Box sx={{ p: { xs: 1.5, sm: 2 } }}>
                        {headerTextParts.length > 1 && (
                          <Box sx={{ mb: 2 }}>
                            <Typography sx={sectionLabelSx}>Header variables</Typography>
                            {headerTextParts.map((part, index) =>
                              index % 2 !== 0
                                ? renderVariable(part, index, headerInputs[(index - 1) / 2], (v) => handleHeaderInputChange((index - 1) / 2, v), `header_${(index - 1) / 2}`)
                                : null
                            )}
                          </Box>
                        )}
                        {textParts.length > 1 && (
                          <Box>
                            <Typography sx={sectionLabelSx}>Body variables</Typography>
                            {textParts.map((part, index) =>
                              index % 2 !== 0
                                ? renderVariable(part, index, inputs[(index - 1) / 2], (v) => handleInputChange((index - 1) / 2, v), `body_${(index - 1) / 2}`)
                                : null
                            )}
                          </Box>
                        )}
                      </Box>
                    )}
                  </>
                ) : (
                  <Stack alignItems="center" justifyContent="center" spacing={1} sx={{ height: "100%", minHeight: 260, px: 2, textAlign: "center", background: `radial-gradient(circle at 50% 30%, ${QR.main}0d 0, transparent 60%)` }}>
                    <Box sx={{ position: "relative", width: 64, height: 64, mb: 0.5 }}>
                      <Box sx={{ position: "absolute", inset: 0, borderRadius: "50%", bgcolor: `${QR.main}0f`, border: `1px dashed ${QR.main}40` }} />
                      <Box sx={{ position: "absolute", inset: 10, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", background: `linear-gradient(135deg, ${QR.main}, ${QR.light})`, boxShadow: `0 8px 18px -10px ${QR.main}` }}>
                        <WhatsAppIcon sx={{ fontSize: 22 }} />
                      </Box>
                    </Box>
                    <Typography sx={{ fontSize: 15, fontWeight: 800, color: "#0f172a" }}>No template selected</Typography>
                    <Typography sx={{ fontSize: 13, color: QR.slate, maxWidth: 280 }}>Choose a template on the left to see how the message will look.</Typography>
                  </Stack>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>

      {/* Footer */}
      <Stack direction="row" justifyContent="flex-end" spacing={1.5} sx={{ px: { xs: 1.5, sm: 2.5 }, py: 1.5, borderTop: `1px solid ${QR.border}`, bgcolor: "#fff" }}>
        <Button
          onClick={handleClose}
          sx={{ height: 44, px: 2.5, borderRadius: 3, textTransform: "none", fontSize: 14.5, fontWeight: 700, color: "#475569", border: "1.5px solid #e2e8f0", "&:hover": { bgcolor: "#f8fafc", borderColor: "#cbd5e1" } }}
        >
          Cancel
        </Button>
        <QrActionButton
          variant="solid"
          color={QR.main}
          gradientTo={QR.light}
          icon={<SendRoundedIcon sx={{ fontSize: 17 }} />}
          label="Send Template"
          loading={status2 === "loading"}
          loadingLabel="Sending..."
          onClick={handleSubmit}
        />
      </Stack>

      <SnackbarMessage
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      />
    </Dialog>
  );
}
